import React, { useMemo } from "react";
import EChart from "./Echart";

const EnergyMixDonut = ({ carriers }) => {
  const data = useMemo(() => {
    return (carriers || [])
      .filter((c) => c.id === "electricity" || c.id === "gas")
      .map((c) => ({
        name: c.label,
        value:
          c.id === "electricity"
            ? Number(c.kWh_canonical || 0)
            : Number(c.kWh_equiv || 0),
      }))
      .filter((d) => d.value > 0);
  }, [carriers]);

  const option = useMemo(() => {
    if (!data.length) return null;

    return {
      tooltip: {
        trigger: "item",
        formatter: (p) =>
          `${p.name}: ${Number(p.value).toFixed(2)} kWh (${p.percent}%)`,
      },
      legend: {
        bottom: 0,
        left: "center",
      },
      series: [
        {
          name: "Mix Energético",
          type: "pie",
          radius: ["55%", "75%"],
          avoidLabelOverlap: true,
          itemStyle: {
            borderRadius: 8,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            show: true,
            formatter: "{d}%",
            fontWeight: "bold",
          },
          labelLine: { show: true },
          data,
        },
      ],
    };
  }, [data]);

  return (
    <div className="em-chart-card">
      <h3>Mix Energético (kWh eq.)</h3>
      {!option ? (
        <div className="em-empty-chart">No hay datos energéticos</div>
      ) : (
        <EChart option={option} style={{ width: "100%", height: 320 }} />
      )}
    </div>
  );
};

export default EnergyMixDonut;